import { MenuItem } from "./menuIItem";
export abstract class AllMenu {         
   
    public static MENU_ITEMS: MenuItem[] = [
        { menuLink: '/home', menuIcon: 'home', menuText: 'menu.home'},
        { menuLink: '/admin', menuIcon: 'account_circle', menuText: 'menu.admin'},
        { menuLink: '/statistics', menuIcon: 'analytics', menuText: 'menu.sales'},
        { menuLink: '/incidents-list', menuIcon: 'warning', menuText: 'menu.breakdowns'},
        { menuLink: '/installations-list', menuIcon: 'flag', menuText: 'menu.locations'},
        { menuLink: '/series-list', menuIcon: 'filter_1', menuText: 'menu.series'},
        { menuLink: '/calls', menuIcon: 'call', menuText: 'menu.calls'},
        { menuLink: '/messages-list', menuIcon: 'mail', menuText: 'menu.messages'},
        { menuLink: '/changelogs', menuIcon: 'info', menuText: 'menu.changelogs'}
    ];
    
    public static getMenuLinks(): string[]{
        let menuLinks: string[] = [];
        this.MENU_ITEMS.forEach(item => {
            menuLinks.push(item.menuLink);
        });
        return menuLinks;
    }
}